/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import { Group, Button, InlineMessage } from '@insticator/insticator-ui';
import LoadingState from '../states/loading/loading';
import NoDataState from '../states/nodata/nodata';
import LinkControls from '../cardwrapper/linkcontrols/linkcontrols';
import CardWrapper from '../cardwrapper/cardwrapper';
// styles
import injectSheet from 'react-jss';
import styles from './chartreportsection_styles';



/* ========== ~~~~~~~~~~ CHART REPORT SECTION ~~~~~~~~~~ ========== */
const ChartReportSection = injectSheet(styles)((props) => {
	const {
		cardtoggles,
		legendTitle,
		tooltipContent,
		chart,
		handleSelectPeriod,
		selectedPeriod,
		enabledPeriods,
		chartLegend,
		detailTable,
        loading,
        noData,
		title,
		note
	} = props;

	const [showDetailTable, setShowDetailTable] = useState(false);

	const isPeriodEnabled = period => (
		enabledPeriods && Array.isArray(enabledPeriods) && enabledPeriods.indexOf(period) >= 0 ? true : false
	);

	return (
		<CardWrapper klass={`chartreportsection ${props.classes.chartreportsection} showNote-${!!note}`} loading={false} tooltipContent={tooltipContent}>
			{ loading && <LoadingState />}
            { !loading && noData && <NoDataState title={title}/>}
			{ !loading && !noData && 
				<div className={'data'}>
					<div className={'chartsection'}>
						<div className={'chart'}>
							<div>{cardtoggles}</div>
              {  !!note &&
                <InlineMessage 
                  key={'note'}
                  display={true}
                  name={'reportnote'}
                  variant={'neutral'}
                  icon={'exclamation-triangle'}
                  title={null}
                  message={note}
                  close={false}
                  handleClose={null} 
                />
              }
              {chart}
							<Group>
								<Button 
									name={'toggledetailstable'} 
									type={'action'} 
									variant={'link'} 
									text={showDetailTable ? 'Hide Details' : 'Show Details'} 
									icon={showDetailTable ? 'chevron-up' : 'chevron-down'} 
									iconRight={true}
									handleClick={() => setShowDetailTable(!showDetailTable)} 
								/>
	                            { !noData && !loading && 
	                                <LinkControls
	                                    selected={selectedPeriod.toLowerCase()}
	                                    handleSelect={handleSelectPeriod}
	                                    options={[
	                                        {text: 'Daily', value: 'daily', disabled: !isPeriodEnabled('daily')},
	                                        {text: 'Weekly', value: 'weekly', disabled:  !isPeriodEnabled('weekly')}, 
	                                        {text: 'Monthly', value: 'monthly', disabled:  !isPeriodEnabled('monthly')},
	                                        {text: 'Quarterly', value: 'quarterly', disabled:  !isPeriodEnabled('quarterly')}
	                                    ]} 
	                                />	
	                            }
							</Group>
						</div>
						<div className={'legend'}>
							<div className={'title'}>{legendTitle}</div>
							<div className={'legend-items'}>
							{chartLegend}
							</div>
						</div>
					</div>
					{showDetailTable && detailTable}  
				</div>
			}
		</CardWrapper>
	);
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ChartReportSection;